<template>
  <!-- @touchstart="handleTouchstart" -->
  <!-- @mousedown="handleMousedown" -->
  <div
    ref="cont"
    class="floating-box floatbox"
    :style="boxStyle"
  >
    <!-- <div style="height: 111px; width: 444px; background: grey"></div> -->
    <!-- <div style="height: 222px; width: 444px; background: darkgrey"></div> -->
    <slot :flbox_methods="flbox_methods"></slot>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { throttle } from 'lodash'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'FloatingBox',
  mixins: [float_mix],
  props: {
    initialPlacement: { default: 'custom' },
    coordinates: { default: () => ({ percentX: 0, percentY: 0 }) },
    referenceElId: String,
    initialReferenceOffset: { default: { x: 0, y: 0 } },

    // boundary: { default: 'window' },
    // boundary: { default: null },
  },
  emits: ['update:coordinates'],
  data() {
    this.flbox_methods = {
      handleMousedown: this.handleMousedown,
      handleTouchstart: this.handleTouchstart,
      // setMousedown: this.setMousedown,
      setMoveXY: this.setMoveXY,
    }
    return {
      mousedown: false,
      mouseEvent: null,
      percentX: 0,
      percentY: 0,

      offsetY: 0,
      offsetX: 0,

      moveX: true,
      moveY: true,

      remPx: 14.5,
    }
  },
  mounted() {
    nextTick(() => {
      requestAnimationFrame(this.initialize)
    })
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    initialize() {
      if (this.initialPlacement === 'custom') {
        this.setCoordinates(this.coordinates)
      } else if (this.initialPlacement === 'reference' && this.referenceElId) {
        const referenceEl = document.getElementById(this.referenceElId)
        const {cont} = this.$refs
        if (!referenceEl) return
        const options = { offset: 8, placement: 'bottom-start' }
        this.fl_setPositionStyle({
          referenceEl,
          boundary: document,
          element: cont,
          options,
        })
      }
    },
    setMousedown(bool) {
      if (this.mousedown === bool) return
      this.mousedown = bool
    },
    setMoveXY({ moveX = true, moveY = true }) {
      if (this.moveX !== moveX) {
        this.moveX = moveX
      }
      if (this.moveY !== moveY) {
        this.moveY = moveY
      }
    },
    handleMouseup() {
      this.setMousedown(false)
      this.removeEventListeners()
      this.emitCoordinates()
    },

    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('mousemove', this.handleMousemove)
      window.removeEventListener('touchend', this.handleMousemove)
      window.removeEventListener('touchmove', this.handleMouseup)
    },
    emitCoordinates() {
      this.$emit('update:coordinates', {
        percentX: this.percentX,
        percentY: this.percentY,
      })
    },
    handleTouchstart(e, { moveX = true, moveY = true } = {}) {
      this.handleStart(e, { moveX, moveY, eventType: 'touchstart' })
    },
    handleMousedown(e, { moveX = true, moveY = true } = {}) {
      this.handleStart(e, { moveX, moveY, eventType: 'mousedown' })
    },
    handleStart(e, { moveX = true, moveY = true, eventType }) {
      this.setMousedown(true)
      this.setMoveXY({ moveX, moveY })

      this.start(e)
      this.move(e)
      if (eventType === 'mousedown') {
        window.addEventListener('mouseup', this.handleMouseup)
        window.addEventListener('mousemove', this.handleMousemove, { passive: false })
      } else {
        window.addEventListener('touchend', this.handleMouseup)
        window.addEventListener('touchmove', this.handleMousemove)
      }
    },
    start(e) {
      let { clientX, clientY } = e
      if (e?.touches) {
        clientY = e?.touches[0]?.clientY
        clientX = e?.touches[0]?.clientX
      }
      this.mouseEvent = { clientX, clientY }

      const { y, x } = this.$refs.cont.getBoundingClientRect()

      this.offsetX = x - clientX
      this.offsetY = y - clientY
    },
    handleMousemove: throttle(function (e) {
      // e.preventDefault()
      if (this.mousedown) {
        this.move(e)
      }
    }, 1),
    move(e) {
      this.setCoordinates(this.getCoordinates(e))
    },
    recomputePosition() {
      if (this.mouseEvent) {
        this.start(this.mouseEvent)
        this.move(this.mouseEvent)
      }
    },
    setCoordinates({ percentX, percentY }) {
      this.percentX = this.moveX ? percentX : this.percentX
      this.percentY = this.moveY ? percentY : this.percentY
    },
    getCoordinates(e) {
      const { x, y, width, height, top, bottom, right } = this.$refs.cont.getBoundingClientRect()

      let { clientX, clientY } = e
      if (e?.touches) {
        clientX = e?.touches[0]?.clientX
        clientY = e?.touches[0]?.clientY
      }

      let pixelX = clientX + this.offsetX
      let pixelY = clientY + this.offsetY

      const maxX = window.innerWidth
      const maxY = window.innerHeight

      // if (this.boundary === 'window') {
      pixelX = pixelX <= 0 ? 0 : pixelX + width >= maxX ? maxX - width : pixelX
      pixelY = pixelY <= 0 ? 0 : pixelY + height >= maxY ? maxY - height : pixelY
      // }
      // else if (this.boundary) {
      //   const cont = this.container
      //   const {
      //     x: minX,
      //     y: minY,
      //     right: c_maxX,
      //     bottom: c_maxY,
      //   } = cont.getBoundingClientRect()

      //   pixelX = pixelX <= minX ? minX : (pixelX + width) >= c_maxX ? (c_maxX - width) : pixelX
      //   pixelY = pixelY <= minY ? minY : (pixelY + height) >= c_maxY ? (c_maxY - height) : pixelY
      // }

      const percentX = pixelX / maxX
      const percentY = pixelY / maxY

      const res = {
        offsetY: this.offsetY,
        offsetX: this.offsetX,
        y,
        x,
        width,
        height,
        top,
        bottom,
        right,
        clientX,
        clientY,
        percentX,
        percentY,
        pixelX,
        pixelY,
      }
      // console.log(res)
      return res
    },
  },
  computed: {
    boxStyle() {
      return {
        top: `${this.percentY * 100}%`,
        left: `${this.percentX * 100}%`,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.floatbox {
  position: fixed;
}
</style>
